
import * as React from "react";
import TextField from '@material-ui/core/TextField';
// @ts-ignore
import InputMask from  "react-input-mask";
const EINNumberField = (props: object) => {
    return <InputMask
            mask="99-9999999"
            {...props}
    >
        {(inputProps: object) => {
         return   <TextField
                    {...inputProps}
                    type="text"
                    variant="outlined"
                    {...props}
            />
        }
        }
    </InputMask>;
};

export default EINNumberField;
